import { PayloadAction, createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit'
import { CONTAINER_DEFINITION_CRUD, WIDGET_DEFINITION_CRUD } from '../../Constants/ApiDefinations'
import mainApiService from '../../Services'
import { setLoader } from './loader.slice'

const initialState: any = {
  tollgatesList: [],
  parametersList: [],
  selectedParametersList: {},
  showRightDrawer: false,
  drawerTitle: '',
  rightDrawerParameterData: {},
  rightDrawerParameterDataIndex: 0,
  selectedDefinitionTab: {} as Record<string, string>,
}

const DefinitionsSlice = createSlice({
  name: 'definitions',
  initialState,
  reducers: {
    resetInitialState: (state) => {
      state.tollgatesList = []
      state.parametersList = []
      state.widgetDefinitionViewData = {}
      state.selectedParametersList = {}
      state.showRightDrawer = false
      state.drawerTitle = ''
      state.rightDrawerParameterData = {}
    },
    setTollgatesList: (state, action: PayloadAction<any>) => {
      const { data = [] } = action.payload || {}
      state.tollgatesList = data
    },
    setParametersList: (state, action: PayloadAction<any>) => {
      const { data = {} } = action.payload || {}
      const { records = [] } = data
      state.parametersList = records.filter((e: any) => e.status === 'ACTIVE')
    },
    setWidgetDefinitionViewState: (state, action: PayloadAction<any>) => {
      const { data = {} } = action.payload || {}
      state.widgetDefinitionViewData = data
    },
    setSelectedParametersList: (state, action: PayloadAction<any>) => {
      state.selectedParametersList = { ...state.selectedParametersList, ...action.payload }
    },
    clearSetSelectedParametersList: (state) => {
      state.selectedParametersList = []
    },
    setShowRightDrawer: (state, action: PayloadAction<any>) => {
      state.showRightDrawer = action.payload
    },
    setRightDrawerParameterData: (state, action: PayloadAction<any>) => {
      state.rightDrawerParameterData = action.payload
    },
    setRightDrawerTitle: (state, action: PayloadAction<any>) => {
      state.drawerTitle = action.payload
    },
    setRightDrawerParameterDataIndex: (state, action: PayloadAction<any>) => {
      state.rightDrawerParameterDataIndex = action.payload
    },
    setSelectedDefinitionTab: (
      state,
      action: PayloadAction<{ accordion: string; tab: string }>,
    ) => {
      if (typeof state.selectedDefinitionTab !== 'object') {
        state.selectedDefinitionTab = {}
      }
      state.selectedDefinitionTab[action.payload.accordion] = action.payload.tab
    },
    setWidgetStatus: (state, action: PayloadAction<any>) => {
      const { data = {} } = action.payload || {}
      state.widgetStatus = data
    },
  },
})

export const {
  resetInitialState,
  setSelectedParametersList,
  clearSetSelectedParametersList,
  setShowRightDrawer,
  setRightDrawerParameterData,
  setRightDrawerTitle,
  setRightDrawerParameterDataIndex,
  setSelectedDefinitionTab,
  setWidgetStatus,
} = DefinitionsSlice.actions
const { setTollgatesList, setParametersList, setWidgetDefinitionViewState } =
  DefinitionsSlice.actions

const definitionsSelector = (state: { definitions: any }) => state.definitions

export const selectTollgatesList = createSelector(
  definitionsSelector,
  (state) => state.tollgatesList,
)

export const selectParametersList = createSelector(
  definitionsSelector,
  (state) => state.parametersList,
)
export const selectwidgetDefinitionViewData = createSelector(
  definitionsSelector,
  (state) => state.widgetDefinitionViewData,
)

export const selectSelectedDefinitionTab = createSelector(
  definitionsSelector,
  (state) => state.selectedDefinitionTab,
)

export const selectSelectedParametersList = createSelector(
  definitionsSelector,
  (state) => state.selectedParametersList,
)

export const selectParametersAddedCount = createSelector([definitionsSelector], (state) => {
  const selectedParametersList = state.selectedParametersList
  if (!selectedParametersList) return 0

  let count = 0
  Object.entries(selectedParametersList).forEach(([key, value]: any) => {
    if (key !== 'additionalParameter') {
      value.tabs.forEach((tab: any) => {
        if (tab?.parameters && tab.parameters.length > 0) {
          count += tab.parameters.length
        }
      })
    }
  })
  return count
})

export const selectShowRightDrawer = createSelector(
  definitionsSelector,
  (state) => state.showRightDrawer,
)

export const selectRightDrawerTitle = createSelector(
  definitionsSelector,
  (state) => state.drawerTitle,
)

export const selectRightDrawerParameterDataIndex = createSelector(
  definitionsSelector,
  (state) => state.rightDrawerParameterDataIndex,
)

export const selectRightDrawerParameterData = createSelector(
  definitionsSelector,
  (state) => state.rightDrawerParameterData,
)

export default DefinitionsSlice

export const getTollgatesListAPICall = createAsyncThunk(
  'widgetDefinition/getTollgatesList',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: any = WIDGET_DEFINITION_CRUD.TOLLGATES_LISTING(payload)
    const data: any = await mainApiService(requestedData)
    dispatch(setTollgatesList(data))
    dispatch(setLoader(false))
    return data
  },
)

export const getParametersListAPICall = createAsyncThunk(
  'widgetDefinition/getParametersList',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: any = WIDGET_DEFINITION_CRUD.PARAMETER_LISTING(payload)
    const data: any = await mainApiService(requestedData)
    dispatch(setParametersList(data))
    dispatch(setLoader(false))
    return data
  },
)

export const createwidgetDefinitionAPICall = createAsyncThunk(
  'widgetDefinition/createwidgetDefinition',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: any = WIDGET_DEFINITION_CRUD.CREATE(payload)
    const data: any = await mainApiService(requestedData)
    dispatch(setParametersList(data))
    dispatch(setLoader(false))
    return data
  },
)

export const updatewidgetDefinitionAPICall = createAsyncThunk(
  'widgetDefinition/updatewidgetDefinition',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: any = WIDGET_DEFINITION_CRUD.UPDATE(payload)
    const data: any = await mainApiService(requestedData)
    dispatch(setLoader(false))
    return data
  },
)

export const getwidgetDefinitionByIdAPICall = createAsyncThunk(
  'widgetDefinition/getwidgetDefinitionById',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: any = WIDGET_DEFINITION_CRUD.GET(payload)
    const data: any = await mainApiService(requestedData)
    dispatch(setWidgetDefinitionViewState(data))
    dispatch(setLoader(false))
    return data
  },
)

export const updatewidgetDefinitionStatusAPICall = createAsyncThunk(
  'widgetDefinition/updatewidgetDefinitionStatus',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: any = WIDGET_DEFINITION_CRUD.UPDATE_STATUS(payload)
    const data: any = await mainApiService(requestedData)
    dispatch(setLoader(false))
    return data
  },
)
export const createContainerDefinitionAPICall = createAsyncThunk(
  'containerDefinition/createContainerDefinition',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: any = CONTAINER_DEFINITION_CRUD.CREATE(payload)
    const data: any = await mainApiService(requestedData)
    dispatch(setParametersList(data))
    dispatch(setLoader(false))
    return data
  },
)

export const updateContainerDefinitionAPICall = createAsyncThunk(
  'containerDefinition/updateContainerDefinition',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: any = CONTAINER_DEFINITION_CRUD.UPDATE(payload)
    const data: any = await mainApiService(requestedData)
    dispatch(setLoader(false))
    return data
  },
)

export const getContainerDefinitionByIdAPICall = createAsyncThunk(
  'containerDefinition/getContainerDefinitionById',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: any = CONTAINER_DEFINITION_CRUD.GET(payload)
    const data: any = await mainApiService(requestedData)
    dispatch(setWidgetDefinitionViewState(data))
    dispatch(setLoader(false))
    return data
  },
)

export const updateContainerDefinitionStatusAPICall = createAsyncThunk(
  'containerDefinition/updateContainerDefinitionStatus',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: any = CONTAINER_DEFINITION_CRUD.UPDATE_STATUS(payload)
    const data: any = await mainApiService(requestedData)
    dispatch(setLoader(false))
    return data
  },
)
